import { useEffect, useRef } from "react";
import useInitAnalytics from "./useInitAnalytics.js";
import { track } from "../common/events/index.js";
export default function useImpression(event, data) {
  useInitAnalytics();
  var tracked = useRef(false);
  useEffect(function () {
    if (!tracked.current && typeof window !== 'undefined') {
      track(event, data);
      tracked.current = true;
    }
  }, [event, data]);
}